module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [
    [_c('v-btn', {
      attrs: {
        "text": ""
      },
      on: {
        "click": _vm.showDialog
      }
    }, [_vm._v("Image")])], _vm._v(" "), _c('v-dialog', {
      attrs: {
        "max-width": "235",
        "min-width": "100",
        "transition": "v-fade-transition",
        "hide-overlay": false,
        "scrollable": ""
      },
      model: {
        value: (_vm.dialogVisible),
        callback: function($$v) {
          _vm.dialogVisible = $$v
        },
        expression: "dialogVisible"
      }
    }, [_c('div', {
      staticClass: "dialog-container"
    }, [_c('div', {
      staticClass: "dialog-body",
      staticStyle: {
        "padding": "25px 35px 0px 35px"
      }
    }, [_c('div', {
      staticStyle: {
        "text-align": "center",
        "margin-bottom": "5px"
      }
    }, [_vm._v("\n                    " + _vm._s(_vm.title) + "\n                ")]), _vm._v(" "), _c('croppa', {
      attrs: {
        "width": 150,
        "height": 150,
        "quality": 1,
        "placeholder": "Choose...",
        "placeholder-font-size": 16,
        "disabled": false,
        "prevent-white-space": true,
        "show-remove-button": true,
        "remove-button-size": 20
      },
      on: {
        "zoom": _vm.imageChanged,
        "move": _vm.imageChanged,
        "file-choose": _vm.imageChanged,
        "image-remove": _vm.imageChanged
      },
      model: {
        value: (_vm.imageObject),
        callback: function($$v) {
          _vm.imageObject = $$v
        },
        expression: "imageObject"
      }
    }, [_c('img', {
      attrs: {
        "slot": "initial",
        "crossOrigin": "Anonymous",
        "src": _vm.displayImage
      },
      slot: "initial"
    })])], 1), _vm._v(" "), _c('div', {
      staticClass: "dialog-footer"
    }, [(_vm.uploading) ? _c('v-progress-circular', {
      staticStyle: {
        "margin-right": "30px"
      },
      attrs: {
        "indeterminate": "",
        "color": "primary"
      }
    }) : _vm._e(), _vm._v(" "), (!_vm.uploading) ? _c('v-btn', {
      attrs: {
        "disabled": !_vm.dirty,
        "text": ""
      },
      on: {
        "click": _vm.upload
      }
    }, [_vm._v("Keep")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
      attrs: {
        "text": ""
      },
      on: {
        "click": function($event) {
          _vm.dialogVisible = false
        }
      }
    }, [_vm._v("Cancel")])], 1)])])
  ], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-699bd659"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ui-elements/ImageEditor.vue
// module id = 2587
// module chunks = 1